export default __webpack_public_path__ + "static/media/Results-Graph_TextureGrey-simple.svg";